import { queryOptions } from '@tanstack/react-query';
import { listDeviceStates } from '~/services/api/fetchers/listDeviceStates.api.ts';
import { BlazeDeviceQueryKey } from '~/services/queryKeys';
import { DeviceStatesListModel } from '~/shared/models/deviceStatesList/DeviceStatesListModel';

export const listDeviceStatesQuery = queryOptions({
  queryKey: [BlazeDeviceQueryKey.LIST_DEVICE_STATES],
  queryFn: async () => {
    const response = await listDeviceStates();
    return new DeviceStatesListModel(response);
  },
});
